import React, { useState } from 'react';
import { X, Layers, Mail, User, CreditCard } from 'react-feather';
import { API_URL } from '../../api';
import { useAuth } from '../../context/AuthContext';

export default function QuickRegisterModal({ isOpen, onClose, onSubmit, loading, eventName }) {
  const [formData, setFormData] = useState({ 
    name: '', 
    email: '', 
    dni: '',
    username: '',
    password: '' 
});
    const { login, user } = useAuth();
    const [ error, setError ] = useState('');

    const generateCredentials = (fullName) => {
        const pass = Math.random().toString(36).slice(-8);

        const words = fullName.trim().split(/\s+/).slice(0, 2).join('');
        const randomNum = Math.floor(100 + Math.random() * 900);
        const user = `${words}${randomNum}`.toLowerCase().replace(/[^a-z0-9.]/g, '');

        return { user, pass };
    }


  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { user, pass } = generateCredentials(formData.name);

    const cleanFormData = {
        name: formData.name.trim(),
        email: formData.email.trim().toLowerCase(),
        dni: formData.dni.trim(),
        username: user,
        password: pass
    };
    
    try {
        const response = await fetch(`${API_URL}/users/`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(cleanFormData),
        });

        if (!response.ok) {
            const data = await response.json();

            throw new Error(data.detail || 'Error en el registro rápido');
        }

        const loginPayload = new URLSearchParams();
        loginPayload.append('username', cleanFormData.username);
        loginPayload.append('password', cleanFormData.password);

        const loginRes = await fetch(`${API_URL}/token`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: loginPayload,
        });

        if (!loginRes.ok) throw new Error('Error al iniciar sesión automática');

        const loginData = await loginRes.json();
        localStorage.setItem('token', loginData.access_token);

        const userRes = await fetch(`${API_URL}/users/me`, {
            headers: { Authorization: `Bearer ${loginData.access_token}` }
        });

        if (!userRes.ok) throw new Error('No se pudo obtener la info del usuario');
        const userData = await userRes.json();

        try {
            await fetch(`${API_URL}/users/send-credentials`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                email: cleanFormData.email,
                username: cleanFormData.username,
                password: cleanFormData.password,
                eventName: eventName 
                }),
            });
            } catch (emailErr) {
            console.error("No se pudo enviar el correo, pero el usuario fue creado:", emailErr);
        }

        onSubmit(userData);

        login(userData);

        window.location.reload();

    } catch (err) {
        setError(err.message.includes("DNI") ? "Este DNI ya está registrado" : err.message);
    }
  };

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/80 backdrop-blur-md p-4 animate-in fade-in duration-300">
      <div className="bg-[#121212] border border-white/10 rounded-3xl w-full max-w-md overflow-hidden shadow-2xl animate-in zoom-in duration-200">
        <div className="p-8">
          <div className="flex justify-between items-start mb-6">
            <div>
              <h2 className="text-2xl font-bold text-white tracking-tight">Registro Rápido</h2>
              <p className="text-gray-400 text-sm mt-1">Consigue tu QR para <span className="text-white font-medium">{eventName}</span></p>
            </div>
            <button onClick={onClose} className="text-gray-500 hover:text-white transition-colors p-2 hover:bg-white/5 rounded-full">
              <X size={20} />
            </button>
          </div>

          <form className="space-y-5" onSubmit={handleSubmit}>
            <div className="space-y-2">
              <label className="text-[10px] uppercase tracking-[0.2em] text-gray-500 font-bold ml-1">Nombre Completo</label>
              <div className="relative">
                <User className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" size={16} />
                <input 
                  required
                  className="w-full bg-white/[0.03] border border-white/10 rounded-xl pl-12 pr-4 py-3.5 text-white focus:border-white/30 focus:bg-white/[0.06] outline-none transition-all"
                  placeholder="Ej. Juan Pérez"
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                />
              </div>
            </div>

            <div className="space-y-2">
              <label className="text-[10px] uppercase tracking-[0.2em] text-gray-500 font-bold ml-1">Correo Electrónico</label>
              <div className="relative">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" size={16} />
                <input 
                  required
                  type="email"
                  className="w-full bg-white/[0.03] border border-white/10 rounded-xl pl-12 pr-4 py-3.5 text-white focus:border-white/30 focus:bg-white/[0.06] outline-none transition-all"
                  placeholder="tu@email.com"
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                />
              </div>
            </div>

            <div className="space-y-2">
              <label className="text-[10px] uppercase tracking-[0.2em] text-gray-500 font-bold ml-1">DNI / Documento</label>
              <div className="relative">
                <CreditCard className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" size={16} />
                <input 
                  required
                  maxLength={8}
                  className="w-full bg-white/[0.03] border border-white/10 rounded-xl pl-12 pr-4 py-3.5 text-white focus:border-white/30 focus:bg-white/[0.06] outline-none transition-all"
                  placeholder="8 dígitos"
                  onChange={(e) => setFormData({...formData, dni: e.target.value})}
                />
              </div>
            </div>

            <button 
              disabled={loading}
              className="w-full bg-white text-black font-bold py-4 rounded-2xl mt-4 hover:scale-[1.02] active:scale-[0.98] transition-all flex items-center justify-center gap-2 shadow-[0_0_20px_-5px_rgba(255,255,255,0.3)] disabled:opacity-50"
            >
              {loading ? "Procesando..." : <>{/*<Layers size={18}/>*/} Obtener mi entrada</>}
            </button>
          </form>
          
          <p className="text-[10px] text-gray-500 text-center mt-6 leading-relaxed">
            Al continuar, crearemos una cuenta automática. Recibirás tus credenciales por email para futuros eventos.
          </p>
        </div>
      </div>
    </div>
  );
}